class ApiaccesslogController {
  constructor() {
    this.name = 'apiaccesslog';
  }
}

export default ApiaccesslogController;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog.controller.js